<template>
  <div>
    <div>表格参数：</div>
    <div>{{ parentData.selected_objects }}</div>
  </div>
</template>

<script>
export default {
  name: "Test2",
  props: {
    parentData: {
      type: Object,
      default() {
        return {}
      }
    },
  }
}
</script>

<style scoped>

</style>